<!--
무자료 등록(재고방식) > stepper
------------------------------------
-->
<template>

    <div class="stepper uk-flex uk-flex-column uk-flex-between uk-flex-stretch">

        <!-- 헤더 -->
        <div class="header">
            무자료 등록과정
        </div>

        <!-- 진행단계 -->
        <step :currentStep="currentStep" :step="1" title="1. 기본정보">
            <div slot="desc">무자료 종류와 회원사를 선택하세요</div>
            <div
                slot="add-info"
                v-show="currentStep > 1"
                class="box-info"
            >
                <div title="종류">
                    <i class="material-icons">info</i>
                    {{ box.name_prefix }}
                </div>
                <div title="회원사">
                    <i class="material-icons">account_circle</i>
                    {{ boxUserNick }}
                </div>
                <div title="보관장소">
                    <i class="material-icons">location_on</i>
                    {{ box.storage }}
                </div>
            </div>
        </step>
        <step :currentStep="currentStep" :step="2" title="2. 상품추가">
            <div slot="desc">박스 내 모든 상품을 하나씩 등록하세요</div>
            <div
                slot="add-info"
                v-show="currentStep > 2"
                class="prods-info"
            >
                <div>
                    <i class="material-icons">info</i>
                    <span class="highlight">{{ prodCount }}</span>
                    개 품목
                </div>
                <div>
                    <i class="material-icons">info</i>
                    총 수량
                    <span class="highlight">{{ totalAmount }}</span>
                    개
                </div>
            </div>
        </step>
        <step :currentStep="currentStep" :step="3" title="3. 라벨출력">
            <div slot="desc">
                라벨 출력 후 무자료 박스를 보관장소로 이동하세요
                <br />
                (보관장소를 수동으로 입력 할 수 있습니다)
            </div>
        </step>
        <step :currentStep="currentStep" :step="4" title="4. 완료">
        </step>
    </div>
</template>

<script>
    export default {
        components: {
            'step': require('./step.vue').default,
        },
        props: {
            /**
             * 현재 진행단계
             */
            currentStep: {
                type: Number,
            },

            /**
             * (object) 박스정보
             * {
             *     tracking_no,
             *     user_id,
             *     name_prefix,
             * }
             */
            box: {
                type: Object,
            },

            /**
             * 등록된 상품정보 배열
             */
            prods: {
                type: Array,
            },

            /**
             * 박스정보의 회원사 닉네임
             */
            boxUserNick: {
                type: String,
            },

            /**
             * 상품 수 (품목)
             */
            prodCount: {
                type: Number,
            },

            /**
             * 총 상품수량
             */
            totalAmount: {
                type: Number,
            },

        },
        data: function () {
            return {
            };
        },
        computed: {

        },
        methods: {

        },


    }
</script>

<style lang="scss" scoped>




    // 스텝
    .stepper {
        //background-color: #fff;
        width: 20rem;
        border-right: 1px solid #666;

        // 헤더
        .header {
            padding: 5px;
            //background-color: #1F2B3D !important;
            background-color: #fff;
            font-size: 1.25rem;
            color: #000;
            text-align: center;
        }
    }

    // 박스정보표시
    .box-info {
        font-size: 1rem;
        //background-color: #1e87f0;
        color: #1e87f0;

        .material-icons {
            color: #666;
            font-size: 1.5rem;
        }
    }
    .prods-info {
        font-size: 1rem;
        color: #666;
        .material-icons {
            font-size: 1.5rem;
        }
        .highlight {
            font-size: 1.25rem;
            font-weight: bold;
            color: #1e87f0;
        }
    }



</style>